import InfoSerializer from './binaryData/InfoSerializer';
import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_12';

const v0_0_12: SerializerRegistry = {
    version,
    binary: {
        InfoSerializer: new InfoSerializer(),
    },
};

export default v0_0_12;
